import { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { EmailVerificationGuard } from '@/components/EmailVerificationGuard';
import LoadingSpinner from '@/components/LoadingSpinner';
import { supabase } from '@/integrations/supabase/client';

const EmailVerification = () => {
  const { loading, isEmailUnverified } = useAuth();
  const [userEmail, setUserEmail] = useState<string | undefined>();

  useEffect(() => {
    const getUserEmail = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        setUserEmail(user.email);
      }
    };

    if (isEmailUnverified) {
      getUserEmail();
    }
  }, [isEmailUnverified]);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isEmailUnverified) {
    // User is verified, redirect will be handled by auth logic
    return <LoadingSpinner />;
  }

  return (
    <EmailVerificationGuard userEmail={userEmail}>
      <div />
    </EmailVerificationGuard>
  );
};

export default EmailVerification;